import React from "react";

const FieldBox = (props) => {
  const {
    children,
    label,
    restProps,
    isLast,
    splitted,
    className,
    splittedWidth = "w-[30.3%]",
    unSplittedWidth = "w-[13%]",
    padding = "p-2",
    contentWidth = "w-[87%]",
    alignItems = "items-center",
  } = props;

  return (
    <div className="flex" {...restProps}>
      <div
        className={`text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey ${
          splitted ? splittedWidth : unSplittedWidth
        } ${alignItems} flex pl-3 ${isLast ? "border-b-1" : " border-b-0"}`}
      >
        {label}
      </div>
      <div
        className={`${contentWidth} ${padding} border ${
          isLast ? "border-b-1" : "border-b-0"
        } ${className}`}
      >
        {children}
      </div>
    </div>
  );
};

export default FieldBox;
